import React from "react";
import { motion } from "motion/react";

const AnimatedText = ({
  text,
  as = "span",
  className = "",
  stagger = 0.04,
  delay = 0,
}) => {
  const MotionTag = motion[as] || motion.span;
  const tokens = React.useMemo(() => text.split(/(\s+)/), [text]);

  const containerVariants = {
    hidden: { opacity: 0, y: 12 },
    show: {
      opacity: 1,
      y: 0,
      transition: { staggerChildren: stagger, delayChildren: delay },
    },
  };

  const wordVariants = {
    hidden: { opacity: 0, y: 10 },
    show: {
      opacity: 1,
      y: 0,
      transition: { type: "spring", stiffness: 180, damping: 18 },
    },
  };

  return (
    <MotionTag className={className} variants={containerVariants}>
      {tokens.map((token, index) =>
        token.trim() === "" ? (
          <span key={`space-${index}`} className="inline-block">
            {"\u00A0".repeat(token.length)}
          </span>
        ) : (
          <motion.span
            key={`word-${index}`}
            className="inline-block"
            variants={wordVariants}
          >
            {token}
          </motion.span>
        ),
      )}
    </MotionTag>
  );
};

export default AnimatedText;
